import React, {useEffect, useState} from 'react';

const UIButton = ({
  label = 'Link Button',
  linkLabel = 'Link Button URL',
  activeLanguage = 'en',
  buttonData = { text: { en: '' }, url: '' },
  setButtonData = () => { },
}) => {

  const [currentText, setCurrentText] = useState('');
  const [currentURL, setCurrentURL] = useState('');

  useEffect(() => {
    if (buttonData) {
      const data = { text: { en: '' }, url: '' };
      data['text'][activeLanguage] = currentText;
      data['url'] = currentURL;
      setButtonData(data);
    }
  }, [
    currentText,
    currentURL,
  ]);

  useEffect(() => {
    const { text, url } = buttonData;
    if (text && text[activeLanguage]) {
      setCurrentText(text[activeLanguage]);
    }
    if (url) {
      setCurrentURL(url);
    }
  }, [
    buttonData,
    activeLanguage,
  ])

  return (
    <div className="w-full mt-2 flex flex-wrap">
      <div className="mr-2">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">{label}</label>
        <input className="appearance-none block
                          bg-gray-200 text-gray-700 border border-red-500
                          rounded py-3 px-4 w-full leading-tight focus:outline-none
                          focus:bg-white"
          type="text"
          onChange={(e) => setCurrentText(e.target.value)}
          value={currentText}
        />
      </div>
      <div className="flex-1">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">{linkLabel}</label>
        <input className="appearance-none block
                          bg-gray-200 text-gray-700 border border-red-500
                          rounded py-3 px-4 w-full leading-tight focus:outline-none
                          focus:bg-white"
          type="text"
          name="url"
          onChange={e => setCurrentURL(e.target.value)}
          value={currentURL}
        />
      </div>
    </div>
  )
};

export default UIButton;